import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import { horaireLong, majuscule } from '../../../annuaire/tunnel/creneaux';

/**
 * FIXERLIGHT-052 lot 1 — les créneaux proposés d'une demande `requested`,
 * converti en heure locale Europe/Paris (même utilitaire que le tunnel de
 * réservation annuaire, `src/annuaire/tunnel/creneaux.js` — un même ISO doit
 * s'afficher pareil partout dans le front).
 *
 * `available`/`reason` existent sur chaque créneau (recalculés côté api à
 * la lecture) mais ne sont pas affichés ici : ce que le client demande à
 * voir ici, ce sont les créneaux qu'IL a proposés, pas leur disponibilité —
 * changer un créneau est hors du lot 1 (aucune action possible).
 */
const ProposedSlotsList = ({ slots }) => {
  const { t } = useTranslation();

  if (!slots || !slots.length) {
    return (
      <Text color="gray.dark" data-testid="workshop-booking-no-slots">
        {t('workshopappointments.card.noslots')}
      </Text>
    );
  }

  return (
    <Box data-testid="workshop-booking-proposed-slots">
      <Text fontWeight={500} mb={1}>
        {t('workshopappointments.card.slots.heading')}
      </Text>
      {slots.map((slot, index) => (
        <Text key={slot.starts_at || index}>
          {majuscule(horaireLong(slot.starts_at))}
        </Text>
      ))}
    </Box>
  );
};

export default ProposedSlotsList;
